(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-mode-switch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-mode-switch')) {
    customElements.define('delivery-mode-switch', class extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('[data-other-mode]');
        const mapElement = this.querySelector('[data-variant-map]');
        if (!link || !mapElement) return;

        let variants;
        try {
          variants = JSON.parse(mapElement.textContent);
        } catch {
          return;
        }

        link.addEventListener('click', () => {
          const details = this.closest('.product-details');
          const selectedId = details?.querySelector('product-form-component input[name="id"]')?.value ||
            new URL(window.location.href).searchParams.get('variant') || this.dataset.initialVariant;
          const selectedVariant = variants.source.find((variant) => String(variant.id) === String(selectedId));
          if (!selectedVariant) return;

          const matchingVariant = variants.target.find((variant) =>
            variant.option1 === selectedVariant.option1 &&
            variant.option2 === selectedVariant.option2 &&
            variant.option3 === selectedVariant.option3
          );
          if (!matchingVariant) return;

          const destination = new URL(link.href);
          destination.searchParams.set('variant', matchingVariant.id);
          link.href = destination.toString();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
